import React, { useEffect } from "react";
import { VideoContext } from "./Video";

const WebCamSourceR = ({ videoRef }) => {
  useEffect(() => {
    (async () => {
      if (!navigator.mediaDevices) {
        alert("Camera indisponível :(");
        return;
      }

      const devices = await navigator.mediaDevices.enumerateDevices();

      const device = devices.find(dev => dev.label.indexOf("back") > -1);

      const constraint = {
        video: device ? { deviceId: device.deviceId } : true
      };

      console.log(constraint);

      const stream = await navigator.mediaDevices.getUserMedia(constraint);

      if (videoRef.current) {
        videoRef.current.srcObject = stream;
      }
    })();
  }, [videoRef]);
  return null;
};

export const Camera = () => (
  <VideoContext.Consumer>
    {videoRef => <WebCamSourceR videoRef={videoRef} />}
  </VideoContext.Consumer>
);
